
/* injects from baggage-loader */

const uploaderDirectiveModule = angular.module('uploader.setting', []);

uploaderDirectiveModule.directive("uploaderSetting", [
  "$window", "$timeout", "$compile", "$templateCache", "$state", "$cookies", "FileUploader", "$rootScope", "Restangular", "blockEditDialog", "Section",
  ($window, $timeout, $compile, $templateCache, $state, $cookies, FileUploader, $rootScope, Restangular, blockEditDialog, Section) => {
    return {
      restrict: "A",
      scope: {
        data: "=ngModel",
        uploadSuccess: '&uploadSuccess'
      },
      templateUrl: settingFolder + "/uploader/template.jade",
      link: (scope, element, attrs, ngModel) => {
        let method = "PUT";
        let siteId, sectionId, urlUploader, aliasUploader, bgId, object;

        const widgetId = attrs.widgetId;
        const widgetEl = angular.element("[data-block-id='" + widgetId + "']");

        scope.url = scope.data;

        if ($rootScope.Editor.mode === 'editor.section') {
          siteId = '/';
        } else {
          siteId = '/sites/' + $state.params.siteId + '/pages/' + $state.params.pageId;
        }

        const sectionAttrPreview = attrs.uploaderSettingSectionPreview;
        const emailAttrPreview = attrs.uploaderSettingEmailPreview;

        scope.sectionAttrVideoCover = attrs.uploaderSettingSectionVideoCover;
        scope.backgroundId = attrs.backgroundId;

        if (sectionAttrPreview) {
          sectionId = attrs.sectionId;
          urlUploader = "" + Restangular.configuration.baseUrl + siteId + "/sections/" + sectionId;
          aliasUploader = "preview";
        } else if (emailAttrPreview) {
          sectionId = attrs.sectionId;
          urlUploader = Restangular.configuration.baseUrl + "/emails/" + sectionId;
          aliasUploader = "preview";
        } else if (attrs.uploaderPhotoId) {
          sectionId = blockEditDialog.getSectionId({ id: widgetId });
          urlUploader = Restangular.configuration.baseUrl + "/sections/" + sectionId + "/widgets/" + widgetId;
          aliasUploader = "photos_attributes[0][file]";
        } else if (attrs.uploaderProductItemId) {
          sectionId = blockEditDialog.getSectionId({ id: widgetId });
          urlUploader = Restangular.configuration.baseUrl + "/sections/" + sectionId + "/widgets/" + widgetId;
          aliasUploader = "product_items_attributes[0][" + attrs.imageAttr + "]";
        } else if (attrs.uploaderProductItemIdRow) {
          sectionId = blockEditDialog.getSectionId({ id: widgetId });
          urlUploader = Restangular.configuration.baseUrl + "/products/" + widgetId + "/product_items/" + attrs.uploaderProductItemIdRow;
          aliasUploader = "[" + attrs.imageAttr + "]";
        } else if (attrs.uploaderImageId) {
          sectionId = attrs.sectionId;
          bgId = attrs.backgroundId;
          aliasUploader = "source";
          object = "sections";
          if (attrs.uploaderImageId === "none") {
            urlUploader = Restangular.configuration.baseUrl + "/sections/" + sectionId + "/images";
            method = "POST";
          } else {
            urlUploader = Restangular.configuration.baseUrl + "/sections/" + sectionId + "/images/" + attrs.uploaderImageId;
          }
        } else if (scope.sectionAttrVideoCover) {
          sectionId = attrs.sectionId;
          urlUploader = "" + Restangular.configuration.baseUrl + siteId + "/sections/" + sectionId;
          aliasUploader = "background_attributes[video_cover]";
        } else if (attrs.siteBg) {
          if (Editor.mode === "email.page.editor") {
            urlUploader = Restangular.configuration.baseUrl + "/sites/" + $state.params.emailId + "/pages/" + $rootScope.currentPage.id;
          } else {
            urlUploader = Restangular.configuration.baseUrl + "/sites/" + $state.params.siteId + "/pages/" + $rootScope.currentPage.id;
          }
          aliasUploader = "background_attributes[image_attributes[source]]";
        } else {
          sectionId = blockEditDialog.getSectionId({ id: widgetId });
          urlUploader = Restangular.configuration.baseUrl + "/sections/" + sectionId + "/widgets/" + widgetId;
          aliasUploader = "image_attributes[source]";
        }

        const setSrc = (newval) => {
          widgetEl.find(".strwimage__image").removeAttr('srcset').attr("src", newval);
        };

        scope.uploader = new FileUploader({
          url: urlUploader,
          autoUpload: true,
          method: method,
          alias: aliasUploader,
          headers: {
            'X-AUTH-TOKEN': Restangular.defaultHeaders['X-AUTH-TOKEN']
          }
        });

        scope.timestamp = (new Date()).getTime();

        const opacity = {
          get: function(rgba) {
            var rgb, rgbaStringArray;
            rgbaStringArray = rgba.match(/[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s]?([\d.]+)[\s+]?/g);
            rgb = rgbaStringArray[0].split(', ');
            return parseInt(rgb[3]);
          },
          set: function(rgba, opacity) {
            var rgb, rgbaStringArray;
            rgbaStringArray = rgba.match(/[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s]?([\d.]+)[\s+]?/g);
            rgb = rgbaStringArray[0].split(', ');
            return "rgba(" + rgb[0] + ", " + rgb[1] + ", " + rgb[2] + ", " + opacity + ")";
          }
        };

        if (attrs.uploaderPhotoId) {
          scope.uploader.onBeforeUploadItem = function(item) {
            const formData = [{
              "photos_attributes[0][id]": attrs.uploaderPhotoId
            }];
            return Array.prototype.push.apply(item.formData, formData);
          };
        }
        if (attrs.uploaderProductItemId) {
          scope.uploader.onBeforeUploadItem = function(item) {
            const formData = [{
              "product_items_attributes[0][id]": attrs.uploaderProductItemId
            }];
            return Array.prototype.push.apply(item.formData, formData);
          };
        }

        scope.uploader.onAfterAddingFile = (item) => {
          return ["image/jpeg", "image/png", "image/svg", "image/gif"];
        };

        scope.uploader.onSuccessItem = (fileItem, response, status, headers) => {
          let finded;

          if (sectionAttrPreview || emailAttrPreview) {
            scope.url = response.preview_url;
          } else if (attrs.uploaderPhotoId) {
            finded = _.filter(response.photos_attributes, {
              id: attrs.uploaderPhotoId
            });
            scope.url = finded[0].file_url;
          } else if (attrs.uploaderProductItemId) {
            finded = _.filter(response.product_items_attributes, {
              id: attrs.uploaderProductItemId
            });
            scope.url = finded[0].file_url;
          } else if (attrs.uploaderProductItemIdRow) {
            scope.url = response.bullet_url;
          } else if (attrs.backgroundId) {
            $timeout(function() {
              var section;
              section = $("[ng-model='section.style_attributes.backgroundColor']").scope().$parent.$parent.section;
              if (opacity.get(section.style_attributes.backgroundColor) === 1) {
                return section.style_attributes.backgroundColor = opacity.set(section.style_attributes.backgroundColor, 0);
              }
            });
            if (!scope.data) {
              scope.data = {};
            }
            scope.data.source_url = response.source_url;
            scope.data.url = response.url;
            scope.data.id = response.id;
            scope.url = response;
            if (attrs.fromEmail) {
              attrs.uploaderImageId = response.id;
            }
          } else if (scope.sectionAttrVideoCover) {
            scope.url.background_attributes.video_cover_url = response.background_attributes.video_cover_url;
          } else if (attrs.siteBg) {
            scope.url = response.background_attributes.image_attributes.source_url;
          } else {
            scope.url = response.image_attributes.source_url;
          }

          scope.uploader.clearQueue();
          scope.$apply();

          $(element).find('input[type="file"]').prop('value', null);

          if (scope.uploadSuccess) {
            scope.uploadSuccess();
          }
        };

        const listener1 = scope.$watch("url", (newval) => {
          if (newval) {
            setSrc(newval);
            if (!newval._destroy) {
              return scope.data = newval;
            }
          }
        }, true);

        scope.$on("$destroy", () => {
          return listener1();
        });
      }
    };
  }
]);



// WEBPACK FOOTER //
// ./src/app/editor/modules_settings/uploader/uploader.directive.js